import { AxiosResponse } from 'axios';
import ApiUrls from '../config/ApiUrls';
import { replaceByObject } from '../utils/Urls';
import API from './Api';

export enum SourceType {
  xero = 'xero',
  googleSheets = 'googleSheets',
  mayday = 'mayday',
}

export enum DataType {
  nominalCodes = 'nominalCodes',
  trackingCategories = 'trackingCategories',
  contacts = 'contacts',
  transactions = 'transactions',
}

export type SourceApiResponse = {
  type: string;
  connected: boolean;
  lastSyncTime: string;
  lastSyncStatus: string;
  lastSyncError: string;
  dataTypes: DataType[];
  externalId: string;
};

export type GroupSources = {
  [key: number]: SourceApiResponse[];
};

export class SourceApi extends API {
  static getGroupSources(groupId: number): Promise<GroupSources> {
    return API.get(replaceByObject(ApiUrls.GroupSources, { groupId })).then(
      (response: AxiosResponse<GroupSources>) => response.data
    );
  }

  static getSources(
    groupId: number,
    entityId: number
  ): Promise<SourceApiResponse[]> {
    return API.get(
      replaceByObject(ApiUrls.Sources, { groupId, entityId })
    ).then((response: AxiosResponse<SourceApiResponse[]>) => response.data);
  }

  static createSource(
    groupId: number,
    entityId: number,
    type: SourceType
  ): Promise<SourceApiResponse> {
    return API.post(replaceByObject(ApiUrls.Sources, { groupId, entityId }), {
      type,
    }).then((response: AxiosResponse<SourceApiResponse>) => response.data);
  }
}
